<template>
    <div>
        <footer class="footer mt-auto py-3 bg-dark fixed-bottom mt-5 d-md-none">
            <slot name="content"></slot>
        </footer>

    </div>

</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped>

</style>
